import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
// import { NgxUsefulSwiperModule } from 'ngx-useful-swiper';
import {IConfig} from 'ngx-mask';
export const options: Partial<IConfig> | (() => Partial<IConfig>) = {};
const routes: Routes = [
];
@NgModule({
    imports: [
        // NgxMaskModule.forRoot(),
        SharedModule,
        RouterModule.forChild(routes),
    ],
    declarations: [
        
    ],
    exports: [
        RouterModule
    ],
    providers: []
})
export class PractinaModule { }



